<template>
  <main>
    <div v-if="quiz" class="courses-page">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/user">{{ $t("my_office") }}</router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link :to="`/course/${quizHeader.quiz.id}`">{{
              quizHeader ? quizHeader.quiz.title : "............"
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="courses-main-info">
        <div class="section-frame">
          <div class="courses-main-content">
            <div class="page-sub-title sub-title-white courses-title">
              <div class="courses-title-star">
                <h1>
                  <i class="fa-title"></i>
                  {{ quizHeader ? quizHeader.quiz.title : "............" }}
                </h1>
              </div>
              <p>{{ quizHeader ? quizHeader.quiz.topic : "............" }}</p>
            </div>
            <div class="courses-data-frame courses-single-data-frame">
              <p class="courses-main-data">
                {{ $t("questions_count")
                }}<span>{{
                  quizHeader ? quizHeader.quiz.questions_count : "............"
                }}</span>
              </p>
              <p class="courses-main-data">
                {{ $t("attempts_count") }}
                <span>{{
                  quizHeader ? quizHeader.quiz.chances.your_chances : "..."
                }}</span>
                /{{
                  quizHeader ? quizHeader.quiz.chances.total_chances : "..."
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="courses-content">
        <div class="section-frame">
          <div class="courses-test">
            <ul class="courses-test-counter" v-if="quiz">
              <li
                v-for="q in quiz.last_page"
                :key="q"
                :class="{ 'active-step': quiz.page === q }"
                @click="getPage(q)"
              >
                {{ q }}
              </li>
            </ul>
            <div class="courses-test-question">
              <div class="courses-title-frame cart-title courses-test-title">
                <i class="fa-title"></i>
                <h2 v-if="quiz && quiz.result">{{ quiz.result[0].title }}</h2>
              </div>
              <div class="test-question-list" v-if="quiz">
                <div
                  v-for="(qu, index) in quiz.result[0].answers"
                  :key="qu.id"
                  class="test-question-item"
                >
                  <div
                    class="cart-ckeck question-ckeck"
                    @click.prevent="resPush(qu.id)"
                    :class="{ 'cart-ckeck-active': qu.status }"
                  >
                    <div class="cart-ckeck-icon"></div>
                    <p>
                      <b>{{ index + 1 }}.</b> {{ qu.title }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="courses-test-btn" v-if="quiz">
              <a
                href="#"
                @click.prevent="getPage('prev')"
                class="courses-test-arrow"
                :class="{ op: quiz.page === 1 }"
                ><i class="fa-arrow-line-back"></i>
                {{ $t("previous_question") }}</a
              >
              <a
                href="#"
                v-if="quiz.page === quiz.last_page && res"
                class="courses-test-reply success"
                @click.prevent="submitAnswer"
                >{{ $t("finish_test") }} <i class="fa-check"></i
              ></a>
              <a
                href="#"
                @click.prevent="getPage('next')"
                class="courses-test-arrow"
                v-if="quiz.last_page !== quiz.page"
                >{{ $t("next_question") }}<i class="fa-arrow-line"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      res: null,
    };
  },
  async beforeCreate() {
    await this.$store.dispatch("getQuizBySlug", this.$route.params.slug);
    await this.$store.dispatch("getQuizByIdHeader", {
      slug: this.$route.params.slug,
    });
    await this.$store.dispatch("getQuizById", {
      slug: this.$route.params.slug,
      page: 1,
    });
  },
  methods: {
    async resPush(id) {
      let answers = [];
      this.res = id;

      // Update answer status with proper reactivity
      this.quiz.result[0].answers.forEach((e) => {
        if (this.quiz.result[0].technique === "Single Choice") {
          // For single choice, set all to false, then set selected to true
          this.$set(e, "status", false);
        }
      });

      // Set the clicked answer to true for single choice
      if (this.quiz.result[0].technique === "Single Choice") {
        const selectedAnswer = this.quiz.result[0].answers.find(
          (e) => e.id === this.res,
        );
        if (selectedAnswer) {
          this.$set(selectedAnswer, "status", true);
        }
      } else if (this.quiz.result[0].technique === "Multiple Choice") {
        // For multiple choice, toggle the clicked answer
        const clickedAnswer = this.quiz.result[0].answers.find(
          (e) => e.id === this.res,
        );
        if (clickedAnswer) {
          this.$set(clickedAnswer, "status", !clickedAnswer.status);
        }
      }

      // Collect selected answers
      let obj = {
        question: null,
        answer: null,
      };
      this.quiz.result[0].answers.forEach((answer) => {
        if (answer.status) {
          answers.push(answer.id);
        }
      });

      // Only validate if we're trying to save/submit, not just selecting an answer
      if (answers.length > 0) {
        obj.answer = answers.toString();
        obj.question = this.quiz.result[0].id;
        await this.$store.dispatch("getQuizSaveAnswer", obj);
      }

      obj = {
        question: null,
        answer: null,
      };
      if (this.quiz.page !== this.quiz.last_page) {
        this.res = null;
      }
    },
    getPage(page) {
      if (page === "prev") {
        this.$store.dispatch("getQuizById", {
          slug: this.$route.params.slug,
          page: this.quiz.page - 1,
        });
      }
      if (page === "next") {
        this.$store.dispatch("getQuizById", {
          slug: this.$route.params.slug,
          page: this.quiz.page + 1,
        });
      } else {
        this.$store.dispatch("getQuizById", {
          slug: this.$route.params.slug,
          page: page,
        });
      }
    },

    async submitAnswer() {
      await this.$store.dispatch("submitQuiz", this.$route.params.slug);
      await this.$router.back();
    },
  },
  computed: {
    quiz() {
      return this.$store.getters.getQuiz;
    },
    quizHeader() {
      return this.$store.getters.getQuizHeader;
    },
    quizInfo() {
      return this.$store.getters.getQuizInfo;
    },
  },
};
</script>
